<template>
    <div class="status-badge">
       <div class="invoice-status success bold-span" :class="[data.edited ? 'paidColor' : 'success']">
            {{data.edited}}
       </div>
    </div>
</template>
<script>
export default {
    data() {
        return {
            data: {}
        }
    }
 }
</script>